import {BaseContainerModel} from '../base-container.model';
import { bl_fi_mst_intercompany_processing_queue_RowInterface, bl_fi_mst_intercompany_processing_queue_RowClass } from '../../dbschema';

export class IntercompanyProcessingQueueContainer extends BaseContainerModel{
    bl_fi_mst_intercompany_processing_queue: bl_fi_mst_intercompany_processing_queue_RowInterface = new bl_fi_mst_intercompany_processing_queue_RowClass();   
}
